import script from "./ota-handle.vue?vue&type=script&setup=true&lang=js"
export * from "./ota-handle.vue?vue&type=script&setup=true&lang=js"

import "./ota-handle.vue?vue&type=style&index=0&id=2fd92f5b&scoped=true&lang=scss"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fd92f5b"]])

export default __exports__